const MODULE_ID = 'telemetrie';
export default MODULE_ID;